import { useCallback } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useHotkeys } from 'react-hotkeys-hook';
import { ChatThread } from '@stores/data.store';
import { ChatHistoryList } from './ChatHistoryList.component';
import { shortid } from '@services/id.service';

interface ChatHistoryProps {
    show: boolean;
    onHide: () => void;
}

export const ChatHistory = ({ show, onHide }: ChatHistoryProps) => {
    const navigate = useNavigate();

    const handleSelectThread = useCallback((thread: ChatThread) => {
        onHide();
        navigate(`/ellie/${thread.thread_id}`);
    }, [navigate, onHide]);

    const handleNewChat = useCallback(() => {
        onHide();
        navigate(`/ellie/${shortid()}`);
    }, [navigate, onHide]);

    return (
        <Offcanvas
            show={show}
            onHide={onHide}
            placement="end"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <i className="mdi mdi-comment-multiple me-2"></i>
                    Chats
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0 d-flex flex-column" style={{ overflow: 'hidden' }}>
                <ChatHistoryList
                    onSelectThread={handleSelectThread}
                    onNewChat={handleNewChat}
                    showHeader={false}
                />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

// Hook to manage chat history visibility with Ctrl+H hotkey
export const useChatHistoryHotkey = (show: boolean, setShow: (show: boolean) => void) => {
    useHotkeys('ctrl+h', (e) => {
        e.preventDefault();
        setShow(!show);
    }, [show, setShow]);
};

export default ChatHistory;
